import React from "react";
import { addOpacityToSystemColor } from "../eldmlTransform/IconTransform";

interface IconViewProps {
  iconName?: string;
  color?: string;
  bgColor?: string;
  size?: number;
  bgOpacity?: string;
  valign?: string;
  borderRadius?: number;
  withBorder?: boolean;
}

const ICON_FONT_SCALE = 0.7;
const ICON_LINE_HEIGHT_OFFSET = 2;

export const countIconFontSize = (size?: number) => {
  return size ? `${ICON_FONT_SCALE * size}px` : undefined;
};

export const countIconLineHeight = (size?: number) => {
  return size ? `${size - ICON_LINE_HEIGHT_OFFSET}px` : undefined;
};

const IconView: React.FC<IconViewProps> = (props) => {
  const sizePx = props.size ? `${props.size}px` : undefined;
  const fontSize = countIconFontSize(props.size);
  const lineHeight = countIconLineHeight(props.size);

  const bgColor =
    props.bgColor && props.bgOpacity
      ? addOpacityToSystemColor(props.bgColor, props.bgOpacity)
      : props.bgColor;

  const style: React.CSSProperties = {
    color: props.color,
    backgroundColor: bgColor,
    borderRadius:
      props.borderRadius !== undefined ? `${props.borderRadius}px` : undefined,
    width: sizePx,
    height: sizePx,
    fontSize,
    lineHeight,
  };

  return (
    <span
      style={style}
      {...(props.valign && { "data-valign": props.valign })}
      {...(props.color && { "data-color": props.color })}
      {...(props.bgColor && { "data-bgcolor": props.bgColor })}
      {...(props.withBorder ? { "data-with-border": "true" } : {})}
    />
  );
};

export default IconView;
